import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Plus, Trash2, Save } from "lucide-react";

export default function UsersAdmin() {
  const [users, setUsers] = useState([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", name: "", role: "editor" });
  const [error, setError] = useState("");

  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    setError("");
    try {
      await api.post("/users", form);
      setCreating(false);
      setForm({ email: "", password: "", name: "", role: "editor" });
      load();
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar este usuario?")) return;
    try {
      await api.delete(`/users/${id}`);
      load();
    } catch (e) {
      alert(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div data-testid="cms-users">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-2xl font-semibold text-[#0F2040]">Usuarios</h1>
          <p className="text-sm text-gray-600">Gestión de cuentas del CMS.</p>
        </div>
        <button onClick={() => setCreating(true)} data-testid="users-add" className="bg-[#C8102E] text-white px-4 py-2.5 text-sm flex items-center gap-2 hover:bg-[#A30D25]">
          <Plus className="w-4 h-4" /> Nuevo usuario
        </button>
      </div>

      {creating && (
        <div className="bg-white border border-gray-200 p-6 mb-6">
          <div className="grid md:grid-cols-2 gap-4">
            <input placeholder="Nombre" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="px-3 py-2 border border-gray-200 text-sm" data-testid="user-name" />
            <input placeholder="Email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="px-3 py-2 border border-gray-200 text-sm" data-testid="user-email" />
            <input placeholder="Contraseña" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="px-3 py-2 border border-gray-200 text-sm" data-testid="user-password" />
            <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="px-3 py-2 border border-gray-200 text-sm" data-testid="user-role">
              <option value="editor">Editor</option>
              <option value="admin">Admin</option>
              <option value="super_admin">Super Admin</option>
            </select>
          </div>
          {error && <p className="text-sm text-red-600 mt-3">{error}</p>}
          <div className="mt-4 flex justify-end gap-2">
            <button onClick={() => setCreating(false)} className="px-4 py-2 text-sm border border-gray-200">Cancelar</button>
            <button onClick={create} data-testid="user-save" className="bg-[#0F2040] text-white px-4 py-2 text-sm flex items-center gap-2"><Save className="w-4 h-4" /> Crear</button>
          </div>
        </div>
      )}

      <div className="bg-white border border-gray-200">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs uppercase tracking-wider text-gray-600">
            <tr>
              <th className="text-left px-5 py-3">Nombre</th>
              <th className="text-left px-5 py-3">Email</th>
              <th className="text-left px-5 py-3">Rol</th>
              <th className="text-right px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-gray-100" data-testid={`user-row-${u.id}`}>
                <td className="px-5 py-3 font-medium text-[#0F2040]">{u.name}</td>
                <td className="px-5 py-3 text-gray-600">{u.email}</td>
                <td className="px-5 py-3"><span className="text-xs px-2 py-0.5 bg-gray-100 uppercase tracking-wider">{u.role}</span></td>
                <td className="px-5 py-3 text-right">
                  <button onClick={() => remove(u.id)} className="p-1.5 text-gray-400 hover:text-red-600">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
